module.exports = __webpack_public_path__ + "img/nf.9c35f8b0.svg";